import UtilsUrl from "../../utils/UtilsUrl";
import api from "../api";

class PromoCaisseService{

  addPromoCaisse(promoCaisseAddModel) {
    return api.post(
      UtilsUrl.PromoCaisseURL() +
        "/savePromoCaisse",promoCaisseAddModel
    );
  }

  getListPromosByIdWarehouse(idUser,idWarehouse) {
    return api.get(
      UtilsUrl.PromoCaisseURL() +
        "/getListPromosByIdWarehouse/"+idUser+"/"+idWarehouse
    );
  }

  desactiverOrActiverPromoGroupe(idUser,idGroupe,active) {
    return api.get(
      UtilsUrl.PromoCaisseURL() +
        "/desactiverOrActiverPromoGroupe/"+idUser+"/"+idGroupe+"/"+active
    );
  }
  getListPromosByGroupe(idUser,idGroupe) {
    return api.get(
      UtilsUrl.PromoCaisseURL() +
        "/getListPromosByGroupe/"+idUser+"/"+idGroupe
    );
  }
}
export default new PromoCaisseService()